import { AiSparkle16 } from 'ui/icons/aurora/16px/AiSparkle16';
import { StyledTooltip } from './CampaignRetargetIconWithTooltip.styles';

type Props = {
  id: number;
};

export const CampaignRetargetIconWithTooltip = ({ id }: Props) => {
  return (
    <StyledTooltip isUnderlined tooltipContent={`Retarget unengaged users with Next Best Action`}>
      <AiSparkle16 data-test={`nba_enabled_${id}`} />
    </StyledTooltip>
  );
};
